import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const BUSINESSES_ALL_REQUEST = 'BUSINESSES_ALL_REQUEST'
export const BUSINESSES_ALL_SUCCESS = 'BUSINESSES_ALL_SUCCESS'
export const BUSINESSES_ALL_FAILURE = 'BUSINESSES_ALL_FAILURE'

export const BUSINESS_BY_NAME_REQUEST = 'BUSINESS_BY_NAME_REQUEST'
export const BUSINESS_BY_NAME_SUCCESS = 'BUSINESS_BY_NAME_SUCCESS'
export const BUSINESS_BY_NAME_FAILURE = 'BUSINESS_BY_NAME_FAILURE'

export const BUSINESS_BY_ID_REQUEST = 'BUSINESS_BY_ID_REQUEST'
export const BUSINESS_BY_ID_SUCCESS = 'BUSINESS_BY_ID_SUCCESS'
export const BUSINESS_BY_ID_FAILURE = 'BUSINESS_BY_ID_FAILURE'

export const fetchAllBusinesses = () => ({
  [CALL_API]: {
    endpoint: '/api/business/businesses?limit=200&offset=0',
    types: [BUSINESSES_ALL_REQUEST, BUSINESSES_ALL_SUCCESS, BUSINESSES_ALL_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const fetchBusinessesByName = (name) => ({
  [CALL_API]: {
    endpoint: `/api/business/businesses/?search=${name}&is_investor_business=false`,
    types: [BUSINESS_BY_NAME_REQUEST, BUSINESS_BY_NAME_SUCCESS, BUSINESS_BY_NAME_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const fetchBusinessesById = (id) => ({
  [CALL_API]: {
    endpoint: `/api/business/businesses/${id}/`,
    types: [BUSINESS_BY_ID_REQUEST, BUSINESS_BY_ID_SUCCESS, BUSINESS_BY_ID_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})
